import { createAxiosInstance } from "./index";
import hostConfig from "@/config/hostResolver";

const baseUrl = process.env.VUE_APP_BUDGET_V2_URL ?? `${hostConfig.apiBaseUrl}/budget-service-ts`;

class BudgetService {
  constructor() {
    this.apiClient = createAxiosInstance(baseUrl);
  }

  async createBudgetPSPSNumbers(body) {
    return (
      await this.apiClient?.post(`/v3/budget-psps-number`, body, {
        errorContext: "Failed to create budget psps numbers",
      })
    )?.data;
  } //createBudgetPSPSNumbers

  async getBudgetPSPSNumbers(params) {
    return (
      await this.apiClient?.get(`/v3/budget-psps-number`, {
        params,
        errorContext: "Failed to get budget psps numbers",
      })
    )?.data;
  } //getBudgetPSPSNumbers

  async deleteBudgetPSPSNumbers(pspsNumberId) {
    return (
      await this.apiClient?.delete(`/v3/budget-psps-number/${pspsNumberId}`, {
        errorContext: "Failed to delete budget psps number",
      })
    )?.data;
  } //deleteBudgetPSPSNumbers
}

export default BudgetService;
